@if(searchService.pages() > 1) {
<div class="flex items-center gap-1">
  <button mat-icon-button class="w-8 h-8 min-h-8" (click)="searchService.previousPage().subscribe()"
          [disabled]="searchService.firstPage()">
    <i-tabler name="chevron-left" class="opacity-80"></i-tabler>
  </button>
  <button mat-icon-button class="w-8 h-8 min-h-8" (click)="searchService.nextPage().subscribe()"
          [disabled]="searchService.lastPage()">
    <i-tabler name="chevron-right" class="opacity-80"></i-tabler>
  </button>
</div>
}
